import React from 'react'
// CSS
import * as css from '../../../auditorias/revision/PanelAuditoria.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class InformativoRendicion extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <div className="col-md-12">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                            <label className="col-sm-4 control-label">Fondos de: <span className="badge badge-secondary">{this.props.fondo.rendidor}</span></label>
                            <label className="col-sm-4 control-label">Desde: <span className="badge badge-secondary">{this.props.fondo.fecha_inicial}</span></label>
                            <label className="col-sm-4 control-label">Hasta: <span className="badge badge-secondary">{this.props.fondo.fecha_final}</span></label>
                            <label className="col-sm-4 control-label">Por Rendir: <span className="badge badge-secondary">{this.props.fondo.fondos_rendir}</span></label>
                            <label className="col-sm-4 control-label">Gastado: <span className="badge badge-secondary">{this.props.fondo.total_gastos}</span></label>
                            <label className="col-sm-4 control-label">Diferencia: <span className="badge badge-secondary">{this.props.fondo.diferencia}</span></label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/detalle-rendicion/InformativoRendicion.jsx